"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCase = void 0;
const words_1 = require("./words");
function camelCase(str) {
    const w = (0, words_1.words)(str);
    if (w.length === 0)
        return '';
    return (w[0].toLowerCase() +
        w
            .slice(1)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(''));
}
exports.camelCase = camelCase;
